<!--
 * @Author: Lemon C
 * @Date: 2024-05-09 11:45:16
 * @LastEditTime: 2025-03-14 16:30:13
-->
<template>
    <div class="sup-docs-md-comp" ref="ref_docs_content_comp">
        <div class="top-box">
            <span class="md-second-title" v-if="docs_md_data.secondTitle && docs_md_data.secondTitle.length">{{ docs_md_data.secondTitle }}</span>
            <span class="last-update-time" v-if="last_update_time_computed.length">{{ last_update_time_computed }}</span>
        </div>
        <DocsExampleMD
            class="content-example-md"
            :docs_content_type="$globalObj.docs_content_type.md"
            :md_content="docs_md_content"
            :update_md_data="update_md_data">
        </DocsExampleMD>
        <NextDocs :next_jump_curr_tree_node_id="md_comp_tree_node_id" />
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance, watch, computed, nextTick } from 'vue';
import DocsExampleMD from '@/components/Docs/DocsExampleMD.vue';
import NextDocs from '@/components/Common/NextDocs.vue';
import { formatTime } from '@/utils/generalMethods';
import { getDocumentByDcId } from '@/service/interface';
import { useStateStore } from '@/stores/state';
import { useMessageStore } from '@/stores/message';

const message_store = useMessageStore();
const state_store = useStateStore();

const { proxy } = getCurrentInstance();

const props = defineProps({
    md_comp_update_data: Function,
    md_comp_tree_node_id: String,
});

const ref_docs_content_comp = ref(null);
const docs_md_data = ref({});
const docs_md_content = ref(''); // markdown内容

watch(
    () => props.md_comp_tree_node_id,
    (val) => {
        service_get_md();
    }
);

const last_update_time_computed = computed(() => {
    let timeStr = '';
    if (docs_md_data.value.creationTime && docs_md_data.value.creationTime.length > 0) {
        timeStr = '最后更新于 ' + formatTime(docs_md_data.value.creationTime);
    }
    if (docs_md_data.value.lastModificationTime && docs_md_data.value.lastModificationTime.length > 0) {
        timeStr = '最后更新于 ' + formatTime(docs_md_data.value.lastModificationTime);
    }
    return timeStr;
});

onMounted(() => {
    service_get_md();
    nextTick(() => {
        window.addEventListener('scroll', win_event_listen_scroll, true);
    });
});

onBeforeUnmount(() => {
    window.removeEventListener('scroll', win_event_listen_scroll);
});

// MARK Service  获取MD文档
const service_get_md = () => {
    let params = {
        dcid: props.md_comp_tree_node_id,
    };
    proxy.$showLoading();
    getDocumentByDcId({ params }).then((res) => {
        proxy.$hideLoading();
        docs_md_content.value = '';
        docs_md_data.value = {};
        if (res.isSuccess) {
            if (res.data != '{}' && Object.keys(res.data).length !== 0) {
                docs_md_data.value = res.data;
                let content = res.data.content;
                // let replacedString = content.replace(/http:/g, 'https:');
                // docs_md_content.value = replacedString;
                docs_md_content.value = content;
                nextTick(() => {
                    // 默认展示顶部
                    ref_docs_content_comp.value.scrollTop = 0;
                });
            }
        }
    });
};
// MARK MD 更新数据
const update_md_data = (md_title_anchors) => {
    let scroll_anchor_list = [];
    if (md_title_anchors.length) {
        scroll_anchor_list = scroll_anchor_list.concat(md_title_anchors);
    }
    proxy.md_comp_update_data(scroll_anchor_list);
};

// MARK listen 滚动
const win_event_listen_scroll = () => {
    if (ref_docs_content_comp.value) {
        let scrollTop = ref_docs_content_comp.value.scrollTop;
        state_store.need_docsBreadcrumb_shadow = scrollTop > 0 ? true : false;
    }

    // 处理文档的锚点联动
    if (!state_store.scroll_anchor_click) {
        doc_scroll_anchor_update();
    } else {
        setTimeout(() => {
            state_store.scroll_anchor_click = false;
        }, proxy.$globalObj.scroll_anchor.__doc_scroll_anchor_click_cancel_time);
    }
};

// 文档滚动触发锚点定位
const doc_scroll_anchor_update = () => {
    const anchor_tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    anchor_tags.forEach((tag) => {
        document.querySelectorAll(tag).forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top >= 0 && rect.top < proxy.$globalObj.scroll_anchor.__doc_scroll_anchor_top_md) {
                message_store.sendMessage(message_store.M_E_SCROLL_ANCHOR, { anchorId: element.id });
            }
        });
    });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-md-comp {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 42px;
    padding-right: 20px;
    box-sizing: border-box;
    .top-box {
        position: relative;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        padding: 25px 20px;
        box-sizing: border-box;

        .md-second-title {
            position: relative;
            color: var(--color-main-text-primary);
            font-size: 30px;
            font-weight: 600;
            line-height: 38px;
        }
        .last-update-time {
            position: relative;
            display: flex;
            align-items: center;
            margin-top: 5px;
            color: var(--color-main-text-secondary);
            font-size: 14px;
            font-variant: tabular-nums;
            line-height: 1.66667;
        }
    }

    :deep(.content-example-md) {
        position: relative;
        display: flex;
        flex: 1;
        width: 100%;
        margin-bottom: 100px;

        .md-editor-preview {
            word-break: unset !important;
        }
    }
}
</style>
